export default __webpack_public_path__ + "static/media/Icon=Doctor Specialization.7bdad7a8.svg";